import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { clearTrackingData } from '../utils/tracking';

const apiBaseQuery = fetchBaseQuery({ baseUrl: '/api' });

export const baseQueryWith401Handling: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    let result = await apiBaseQuery(args, api, extraOptions)

    if (result.error && result.error.status === 401) {
        clearTrackingData();
        window.location.href = '/login';
    }

    return result;
}